export default function getNormalizedBounds(map) {
  let boundingBox = map.getBounds();
  const nw = boundingBox.getNorthWest().wrap();
  const se = boundingBox.getSouthEast().wrap();
  return {
    nw: `${nw.lat}, ${nw.lng > se.lng ? nw.lng * -1 : nw.lng}`,
    se: `${se.lat}, ${se.lng < nw.lng ? se.lng * -1 : se.lng}`,
  };
}
